import React from "react";
import { Container, Row, Table, Button, Form, Col, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DndContext } from '@dnd-kit/core';
import { ArrowsMove, BoxArrowInDownRight, PlusCircleDotted } from "react-bootstrap-icons";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import { Draggable } from "presentation/components/drag-and-drop-elements/draggable";
import { Droppable } from "presentation/components/drag-and-drop-elements/droppable";
import CancelButton from "presentation/components/buttons/cancel";

import ClassroomTimesheetTips from "presentation/pages/classrooms/elements/classroom-timesheet-tips";

import { handleResultData, isoDayOfWeekList, timeList, goTo } from "presentation/utils/functions/generic";

import classroomsService from "presentation/services/classrooms";
import timesheetsService from "presentation/services/timesheets";
import timesheetStructuresService from "presentation/services/timesheet-structures";
import timesheetActivitiesService from "presentation/services/timesheet-activities";
import courseDisciplinesService from "presentation/services/course-disciplines";
import { setComponentFlag, handleChange } from "presentation/utils/functions/generic";
import { TIMESHEET_ITEM_ENTITY_TYPE_ACTIVITY, TIMESHEET_ITEM_ENTITY_TYPE_DISCIPLINE } from "presentation/model/constants";

class ClassroomTimesheetManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      loading: true,
      actionLoading: false,
      error: false,
      message: '',
      timesheetStructureList: [],
      timesheetRawValues: [],
      classroom: {
        name: ''
      },
      selectedTimesheetStructure: null,
      isDragging: false
    };
    this.loadData = this.loadData.bind(this);
  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    const { handleChangeTimesheetStructure, handleActivityNames } = this;
    await classroomsService.findById(id).then((result) => {
      let handledResult = handleResultData(result);


      this.setState({ classroom: handledResult, classroomId: id }, async () => {
        const { classroom } = this.state;
        await courseDisciplinesService.search({ courseId: [parseInt(classroom.courseId)], academicPeriodId: [parseInt(classroom.academicPeriodId)] }).then((classroomDisciplines) => {
          let handledDisciplines = handleResultData(classroomDisciplines);
          this.setState({ disciplines: handledDisciplines });
        });
      });
    });

    await timesheetsService.search({ classroomId: [parseInt(id)] }).then((result) => {
      let handledResult = handleResultData(result);
      var firstOrDefault = handledResult[0] ? handledResult[0] : {};

      this.setState({ timesheet: firstOrDefault, form: firstOrDefault, timesheetRawValues: firstOrDefault.timesheetItems || [] });
    });

    await timesheetStructuresService.findAll().then((structures) => {


      let handledStructure = handleResultData(structures);
      var timesheetStructureList = handledStructure.map((e, i) => {
        return { id: e.id, name: e.name };
      });

      this.setState({ timesheetStructures: handledStructure, timesheetStructureList: timesheetStructureList });
    });

    await timesheetActivitiesService.findAll().then((timesheetActivities) => {
      let handledTimesheetActivities = handleResultData(timesheetActivities);
      this.setState({ timesheetActivities: handledTimesheetActivities }, () => {
        const { timesheet } = this.state;
        if (timesheet) {
          handleActivityNames();
          handleChangeTimesheetStructure(timesheet.timesheetStructureId);
        }

        this.setState({ loading: false });
      });
    });
  }
  handleActivityNames = () => {
    const { disciplines, timesheetActivities, timesheetRawValues } = this.state;
    let handled = timesheetRawValues.map((ti, tix) => {
      if (!ti.entityName) {

        if (ti.timesheetEntityType == 'Discipline') {
          let entity = disciplines.filter(x => x.disciplineId == ti.entityId)[0];
          if (entity) {

            ti.entityName = entity.discipline.displayName;
          }
        } else {
          let entity = timesheetActivities.filter(x => x.id == ti.entityId)[0];
          if (entity) {
            ti.entityName = entity.displayName;
          }
        }
      }

      return ti;
    });

  }
  handleChangeTimesheetStructure = (timesheetStructureId) => {
    const { timesheetStructures } = this.state;

    let selectedTimesheetStructure = timesheetStructures.filter(x => x.id == timesheetStructureId)[0];

    if (selectedTimesheetStructure != null) {
      selectedTimesheetStructure.items = selectedTimesheetStructure.timesheetStructureItems.sort((a, b) => a.order - b.order);

      let daysOfWeek = selectedTimesheetStructure.daysOfWeek.split(',').map((dow, dowi) => parseInt(dow));
      let isoDaysOfWeek = isoDayOfWeekList();
      let timesheetDaysOfWeek = [];

      for (let i = 0; i < isoDaysOfWeek.length; i++) {
        let e = isoDaysOfWeek[i];
        if (daysOfWeek.includes(e.dayOfWeek)) {
          timesheetDaysOfWeek.push(e);
        }
      }

      this.setState({ selectedTimesheetStructure: selectedTimesheetStructure, timesheetDaysOfWeek: timesheetDaysOfWeek, form: { ...this.state.form, timesheetStructureId: timesheetStructureId } });
    } else {
      this.setState({ selectedTimesheetStructure: null, timesheetDaysOfWeek: null, timesheetRawValues: [], form: { ...this.state.form, timesheetStructureId: undefined } });
    }

  }

  droppableArea = (structureItemId, dayOfWeek) => {
    const { resetDroppable } = this;
    const { timesheetRawValues, isDragging } = this.state;
    var existing = timesheetRawValues.filter(x => x.dayOfWeek == dayOfWeek && x.timesheetStructureItemId == structureItemId)[0];
    var intDayOfWeek = parseInt(dayOfWeek);
    let droppableLabel = isDragging == true ? <><BoxArrowInDownRight /><br /><small>arraste para cá</small></> : <PlusCircleDotted />;

    if (existing) {
      let { entityName } = existing;

      return <Alert variant="success" onClose={() => resetDroppable(structureItemId, intDayOfWeek)} dismissible> <p>{entityName}</p></Alert>;
    } else {
      return <Droppable id={`droppable-${structureItemId}-${dayOfWeek}`} data={{ timesheetStructureItemId: structureItemId, dayOfWeek: intDayOfWeek }}>{droppableLabel}</Droppable>
    }
  }

  handleDroppableAreaClick = (structureItemId, dayOfWeek) => {

    const { timesheetRawValues } = this.state;
    var existing = timesheetRawValues.filter(x => x.dayOfWeek == dayOfWeek && x.timesheetStructureItemId == structureItemId)[0];

    if (!existing) {
      setComponentFlag(this, "showDragTip", true);
    }
  }

  resetDroppable = (timesheetStructureItemId, dayOfWeek) => {
    const { timesheetRawValues } = this.state;
    let existing = timesheetRawValues.filter(x => !(x.dayOfWeek == dayOfWeek && x.timesheetStructureItemId == timesheetStructureItemId));

    this.setState({ timesheetRawValues: existing });
  }

  handleDragStart = (event) => {
    this.setState({ isDragging: true });
  }
  handleDragEnd = (event) => {

    const { over: destination, active: origin } = event;

    if (origin && destination) {
      const { timesheetRawValues } = this.state;

      let { timesheetEntityType, entityId, entityName } = origin.data.current;
      let { timesheetStructureItemId, dayOfWeek } = destination.data.current;

      //avoid duplicates on save stage
      let existing = timesheetRawValues.filter(x => !(x.dayOfWeek == dayOfWeek && x.timesheetStructureItemId == timesheetStructureItemId));

      let newTimesheetRawValues = [...existing, { timesheetEntityType, entityId, entityName, timesheetStructureItemId, dayOfWeek }];
      this.setState({ timesheetRawValues: newTimesheetRawValues });
    }

    this.setState({ isDragging: false });

  }

  handleSubmit = async () => {

    const { timesheetRawValues, classroomId } = this.state;
    this.setState({ loading: true });

    const {
      timesheetStructureId,
      startTime,
    } = this.state.form;

    if (!timesheetStructureId || !startTime) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um horário de início e/ou escolha uma estrutura de quadro de horários..." });
    } else {
      let postData = this.state.form;
      postData.classroomId = classroomId;
      postData.timesheetItems = timesheetRawValues.map((x, i) => { delete x.id; return x });
      try {
        const response = await timesheetsService.manage(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {
          goTo("/turmas", this);
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  }

  render() {
    let component = this;
    const {
      loading,
      actionLoading,
      error,
      message,
      form,
      classroom,
      timesheet,
      timesheetStructureList,
      timesheetActivities,
      disciplines,
      selectedTimesheetStructure,
      timesheetDaysOfWeek,
      timesheetRawValues
    } = this.state;

    const {
      handleDragStart,
      handleDragEnd,
      handleChangeTimesheetStructure,
      droppableArea,
      handleDroppableAreaClick,
      handleSubmit
    } = this;

    let emptyTimesheet = timesheetRawValues.length < 1;
    let timeOptions = timeList();

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error === false && timesheet.timesheetItems == null && <PageAlert className="m-b-20" message={"Sem informações"} description={"Essa turma ainda não tem quadro de horários cadastrado..."} type="info" dismissible />}
        {loading === false && (
          <Container>
            <Row>
              <h4>{classroom.name}</h4>
              <Container>
                <Form>
                  <div className="form mt-2">
                    <Form.Label htmlFor="startTime">Horário de início</Form.Label>
                    <Form.Select
                      aria-label="Horário de início"
                      defaultValue={form.startTime}
                      id="startTime"
                      name="startTime"
                      onChange={(e) => handleChange(e, component)}
                      aria-describedby="startTimeHelpBlock"
                      required
                    >
                      <option value={-999}>Selecione um horário</option>
                      {timeOptions.map((e, i) => { return <option key={e.key} value={e.time}>{e.time}</option> })}
                    </Form.Select>
                    <Form.Text id="startTimeHelpBlock" muted>
                      Informe o horário de início das atividades
                    </Form.Text>
                  </div>
                  <div className="form mt-2">
                    <Form.Label htmlFor="timesheetStructureId">Estrutura de quadro de horários</Form.Label>
                    <Form.Select
                      aria-label="Estrutura de quadro de horários"
                      defaultValue={form.timesheetStructureId}
                      id="timesheetStructureId"
                      name="timesheetStructureId"
                      onChange={(e) => handleChangeTimesheetStructure(e.target.value)}
                      aria-describedby="timesheetStructureIdHelpBlock"
                      required
                    >
                      <option value={-999}>Selecione uma estrutura</option>
                      {timesheetStructureList.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                    </Form.Select>
                    <Form.Text id="timesheetStructureIdHelpBlock" muted>
                      Defina uma estrutura do quadro de horários
                    </Form.Text>
                  </div>
                </Form>
                {
                  selectedTimesheetStructure != null && timesheetDaysOfWeek != null && (
                    <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                      <Row className="mt-4">
                        <Col xs={2}>
                          <h5>Atividades</h5>
                          {disciplines.length > 0 && disciplines.map((d, di) => <Draggable key={`draggable-d-${d.discipline.id}`} id={`draggable-d-${d.discipline.id}`} data={{ "entityId": d.discipline.id, timesheetEntityType: TIMESHEET_ITEM_ENTITY_TYPE_DISCIPLINE, entityName: d.discipline.name }}>{d.discipline.name} <ArrowsMove /></Draggable>)}
                          <hr />
                          {timesheetActivities.length > 0 && timesheetActivities.map((ta, tai) => <Draggable key={`draggable-ta-${ta.id}`} id={`draggable-ta-${ta.id}`} data={{ "entityId": ta.id, timesheetEntityType: TIMESHEET_ITEM_ENTITY_TYPE_ACTIVITY, entityName: ta.displayName }}>{ta.displayName} <ArrowsMove /></Draggable>)}
                        </Col>
                        <Col>
                          <h5>Quadro de horários</h5>
                          <Table className="table table-bordered mt-4 timesheet-manage-table">
                            <thead>
                              <tr>
                                <th></th>
                                {timesheetDaysOfWeek.map((d, di) => <th className="text-center" key={di}>{d.name}</th>)}
                              </tr>
                            </thead>
                            <tbody>
                              {selectedTimesheetStructure.items.length > 0 && selectedTimesheetStructure.items.map((element, index) => {
                                return (
                                  <tr key={element.id}>
                                    <td className="text-center"><strong>{element.name}</strong></td>
                                    {timesheetDaysOfWeek.map((d, di) => <td key={di} className="text-center" onClick={() => handleDroppableAreaClick(element.id, d.dayOfWeek)}>{droppableArea(element.id, d.dayOfWeek)}</td>)}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </DndContext>
                  )
                }
              </Container>
              <div className="mt-3 mb-5">
                <CancelButton
                  containerProps={{
                    as: Link,
                    to: `/turmas`
                  }}
                />
                <Button disabled={loading || emptyTimesheet} variant="success" className="float-end" onClick={async () => await handleSubmit()}>Salvar</Button>
              </div>
            </Row>
            <ClassroomTimesheetTips component={this} tipFlag={'showDragTip'} />
          </Container >
        )
        }
      </div>
    );
  };
}

export default ClassroomTimesheetManage;
